module.exports = __webpack_public_path__ + "img/picture-in-picture.81c28653.png";